import { render, staticRenderFns } from "./ProductTcoCard.vue?vue&type=template&id=676e1c5a"
import script from "./ProductTcoCard.vue?vue&type=script&lang=js"
export * from "./ProductTcoCard.vue?vue&type=script&lang=js"
import style0 from "./ProductTcoCard.vue?vue&type=style&index=0&id=676e1c5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports